import React, { useState } from "react";
import {
  TextField,
  Button,
  Alert,
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
const backendURL = process.env.REACT_APP_TWCHATBOT_DOMAINS;

  const navigate = useNavigate();

  // ✅ Validation rules
  const rules = [
    { label: "Between 8 and 20 characters", test: (pwd) => pwd.length >= 8 && pwd.length <= 20 },
    { label: "At least one letter", test: (pwd) => /[A-Za-z]/.test(pwd) },
    { label: "At least one number", test: (pwd) => /\d/.test(pwd) },
    { label: "At least one special character", test: (pwd) => /[^A-Za-z0-9]/.test(pwd) },
  ];

  const ruleChecks = rules.map((rule) => ({
    label: rule.label,
    valid: rule.test(newPassword),
  }));

  const allRulesValid = ruleChecks.every((r) => r.valid);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!allRulesValid) {
      setError("Password does not meet all requirements.");
      return;
    }

    try {
      const response = await fetch(`${backendURL}/internal/change_password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: localStorage.getItem("pending_user_id"),
          old_password: oldPassword,
          new_password: newPassword,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.error || "Failed to change password");
        return;
      }

      setSuccess("✅ Password changed successfully! Please login again.");
      localStorage.removeItem("pending_user_id");
      localStorage.removeItem("pending_email");
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      setError("Server error. Try again.");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "64px", // 👈 adjust to your navbar height
        left: 0,
        width: "100%",
        height: "calc(100vh - 64px)", // remaining screen
        backgroundColor: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        zIndex: 1200, // make sure it's above background but below navbar
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        
      }}
    >
      <Paper
        sx={{
          p: 4,
          maxWidth: 500,
          width: "90%",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          backgroundColor: "#fff",
          maxHeight: 400,    
          overflowY: "auto",
        }}
      >
        <h2 style={{ marginBottom: "16px", color: "#153052", textAlign: "center" }}>
          Change Your Password
        </h2>
        <form onSubmit={handleChangePassword}>
          <TextField
            type="password"
            label="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            type="password"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            type="password"
            label="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
          />

          {/* ✅ Show rules only when typing */}
          {newPassword.length > 0 && (
            <List dense sx={{ mb: 2 }}>
              {ruleChecks.map((rule) => (
                <ListItem key={rule.label}>
                  <ListItemIcon>
                    {rule.valid ? (
                      <CheckCircleIcon sx={{ color: "green" }} fontSize="small" />
                    ) : (
                      <CancelIcon sx={{ color: "red" }} fontSize="small" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={rule.label}
                    primaryTypographyProps={{ sx: { fontSize: "0.9rem" } }}
                  />
                </ListItem>
              ))}
            </List>
          )}

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {success}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 1,
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: "#153052",
              "&:hover": { backgroundColor: "#0f2744" },
            }}
            disabled={!oldPassword || !newPassword || !confirmPassword}
          >
            Change Password
          </Button>
        </form>
      </Paper>
    </div>
  );
};

export default ChangePassword;
